/**
 * patrol-arrests-bites-view.js
 */

import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Types } from 'utils/constants';
import ArrestsView from './arrests-view';
import IconSection from 'components/icon-section';
import InfoRow from 'components/info-row';



export default function PatrolArrestsBitesView(props) {
  const { 
    deployment,
    record,
   } = props;
  const { t } = useTranslation('deploymentEdit');
  const isShown = Boolean(
    record.peopleFoundCount > 0
    || record.peopleUnintentionallyBittenCount > 0
    || record.arrests?.length > 0
  );

  if (!isShown) return null;
  
  const arrestsWithBitesCount = record.arrests?.filter(arrest => arrest.wasSubjectBitten)?.length ?? 0;


  return (
    <>
      <IconSection iconName='patrol-arrests-bites'>

        {/* people found */}
        {record.peopleFoundCount > 0 &&
          <InfoRow
            title={t('arrests-bites.arrests-bites.label')}
            text={record.peopleFoundCount}
          />}

        {/* unintentional bites */}
        {record.peopleUnintentionallyBittenCount > 0 &&
          <InfoRow
            title={t('arrests-bites.peopleUnintentionallyBitten.label')}
            text={record.peopleUnintentionallyBittenCount}
          />}
        
        {/* total arrests */}
        {record.arrests?.length > 0 &&
          <InfoRow
            title={t('arrests-bites.totalArrests.label')}
            text={record.arrests?.length}
          />}

        {/* arrests with bites */}
        {record.arrests?.length > 0 &&
          <InfoRow
            title={t('arrests-bites.arrestsWithBites.label')}
            text={arrestsWithBitesCount}
          />}

        <Box mt={3} />

        <ArrestsView
          deployment={deployment}
          record={record}
          workMode={Types.WorkMode.PATROL}
        />

      </IconSection>
    </>
  );
}